import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DisplayType = 'loading' | 'products' | 'workflows' | 'threads' | 'files' | 'search' | 'contractorDashboard' | 'usage' | 'comments' | 'edit';

interface DisplayTypeState {
    type: DisplayType;
}

const initialState: DisplayTypeState = {
    type: 'loading'
};

const displayTypeSlice = createSlice({
    name: 'displayType',
    initialState,
    reducers: {
        setDisplayType: (state, action: PayloadAction<DisplayType>) => {
            state.type = action.payload;
            if (typeof window !== 'undefined') {
                localStorage.setItem('lastDisplayType', action.payload);
            }
        }
    }
});

export const { setDisplayType } = displayTypeSlice.actions;
export default displayTypeSlice.reducer; 